<template>
    <span>{{displayBrand}} card ending in {{last4}} expiry date {{expiryMonth}}/{{expiryYear}}</span>
</template>
<script>

export default {
    props: {
        last4: {
            type: String,
            required: true
        },
        brand: {
            type: String,
            required: true
        },
        expiryMonth: {
            type: Number,
            required: true
        },
        expiryYear: {
            type: Number,
            required: true
        }
    },

    data: function () {
        return {
            selected_payment_method: "credit_card",
            payment_details: {
                payment_amount: 0,
                payment_date: null,
                payment_reference: null,
            },
            invoice: null,
            payment_options: null,
            stripe: null,
            elements: null,
            card: null,
            stripe_pk: '',
            stripe_account: '',
            cardholder_name: '',
            save_card: false,
            errors: [],
            success: false,
            payment: null
        };
    },
    computed: {
        displayBrand: function () {
            switch (this.brand) {
                case 'visa':
                    return 'Visa';
                case 'mastercard':
                    return 'Mastercard';
                case 'amex':
                    return 'American Express';
                default:
                    return 'Unknown';
            }
        }
    }
}
</script>
